import { render, staticRenderFns } from "./DashboardSuccess.vue?vue&type=template&id=0d62bb24&scoped=true&"
import script from "./DashboardSuccess.vue?vue&type=script&lang=js&"
export * from "./DashboardSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d62bb24",
  null
  
)

export default component.exports